module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CUQHKt/tc-custom/9781035812172.jpg?1724535395974",
      "alt": "This image is the cover for the book Waster Well"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Waster Well\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Waster Well is about a young boy named Sam who ends up moving to a small town called Wilmington. Now this town has a big secret that they would like to remain hidden. But as Sam has just moved to Wilmington, he is curious to find out more about the town and he tries his hardest to do so. As Sam begins to find out more about the town, he doesn’t realise that his curiosity is going to get the better of him because it is only a matter of time before Sam uncovers the truth about the town’s past. When Sam starts to uncover what everyone has been hiding, he is about to do something that the town thought would never happen. For Sam manages to bring the monster back, which the town had kept hidden for so long because of what it did the last time it was around. But Sam doesn’t realise what he has done until it is almost too late. Can Sam realise his mistake before it all gets out of hand? Only time will tell, and time isn’t on Sam’s side.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Danni Rowe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Danni Rowe was born in Cardiff in 1982, where she spent her childhood living in Rumney. When Danielle left school, she studied to become a nursery nurse. Then when she was 19 years old, she got the opportunity to work in a nursery setting. From then until now, Danielle has worked in different nursery settings, working with children aged from six weeks up to 11 years. This is where her inspiration came from to write Waster Well. Danielle now lives in Barry with her dog Mickey and still works with children.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0